// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.modal {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;
}

.modal__container {
    margin: var(--space);
    /* border: 8px solid var(--primary-light-color); */
    background: var(--white-color);
    padding: var(--space-x2) var(--space);
    padding-bottom: var(--space);
    position: relative;
    max-width: 600px;
    border-radius: 14px;
    box-shadow: 0px 1px 4px rgba(150, 150, 150, 0.25);
}
.modal__container__close {
    display: flex;
    position: absolute;
    top: 8px;
    right: 8px;
    /* border: var(--border);
    border-top: none;
    border-right: none; */
    background-color: var(--white-color);
}
.modal__container__close:hover {
    cursor: pointer;
}

.modal__container .modal-title {
    font-family: var(--primary-font);
    font-weight: var(--font-medium);
    font-size: var(--space-and-half);
    line-height: var(--space-x2);
    color: var(--primary-very-dark-color);
    margin-bottom: var(--space);
}
.modal__container .modal-text {
    font-family: var(--secondary-font);
    font-weight: var(--font-regular);
    font-size: var(--space);
    line-height: var(--space-and-half);
    letter-spacing: 0.005em;
    color: var(--primary-dark-color);
    margin-bottom: var(--space-and-half);
}`, "",{"version":3,"sources":["webpack://./src/shared/components/modal/ModalComponent.styles.css"],"names":[],"mappings":";AACA;IACI,eAAe;IACf,MAAM;IACN,SAAS;IACT,OAAO;IACP,QAAQ;IACR,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,oBAAoB;IACpB,kDAAkD;IAClD,8BAA8B;IAC9B,qCAAqC;IACrC,4BAA4B;IAC5B,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,iDAAiD;AACrD;AACA;IACI,aAAa;IACb,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV;;yBAEqB;IACrB,oCAAoC;AACxC;AACA;IACI,eAAe;AACnB;;AAEA;IACI,gCAAgC;IAChC,+BAA+B;IAC/B,gCAAgC;IAChC,4BAA4B;IAC5B,qCAAqC;IACrC,2BAA2B;AAC/B;AACA;IACI,kCAAkC;IAClC,gCAAgC;IAChC,uBAAuB;IACvB,kCAAkC;IAClC,uBAAuB;IACvB,gCAAgC;IAChC,oCAAoC;AACxC","sourcesContent":["\n.modal {\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    background-color: rgba(0, 0, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 100;\n}\n\n.modal__container {\n    margin: var(--space);\n    /* border: 8px solid var(--primary-light-color); */\n    background: var(--white-color);\n    padding: var(--space-x2) var(--space);\n    padding-bottom: var(--space);\n    position: relative;\n    max-width: 600px;\n    border-radius: 14px;\n    box-shadow: 0px 1px 4px rgba(150, 150, 150, 0.25);\n}\n.modal__container__close {\n    display: flex;\n    position: absolute;\n    top: 8px;\n    right: 8px;\n    /* border: var(--border);\n    border-top: none;\n    border-right: none; */\n    background-color: var(--white-color);\n}\n.modal__container__close:hover {\n    cursor: pointer;\n}\n\n.modal__container .modal-title {\n    font-family: var(--primary-font);\n    font-weight: var(--font-medium);\n    font-size: var(--space-and-half);\n    line-height: var(--space-x2);\n    color: var(--primary-very-dark-color);\n    margin-bottom: var(--space);\n}\n.modal__container .modal-text {\n    font-family: var(--secondary-font);\n    font-weight: var(--font-regular);\n    font-size: var(--space);\n    line-height: var(--space-and-half);\n    letter-spacing: 0.005em;\n    color: var(--primary-dark-color);\n    margin-bottom: var(--space-and-half);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
